import React, { Component } from "react";
import { Select, Spin, Button, message } from "antd";
import ScGridTable from "@/components/display/table/gridTableCore";
import { getStationOrEquRank } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import ExportJsonExcel from 'js-export-excel';
class Top100Equipment extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      tableConfig: null,
      sortType: "0",
      sortOrder: "-1",
      dataSource: [],
      addDisabled:false,
      loading: false,
    };
  }

  componentWillMount() {
    // 预设表单配置项，防止gridTableCore初始化失败
    this.initTableConfig();
    this.handleGetDataSource();
  }

  /** */
  initTableConfig = () => {
    this.setState({
      tableConfig: {
        tableKey: "chargeSuccessTop10StationTable",
        tableColumns: [
          {
            name: "排名",
            key: "serial",
            colType: "textCol",
            align: "center",
          },
          {
            name: "设备",
            key: "stubId",
            colType: "textCol",
            align: "left",
            render: (text, record) => {
              return (
                <a
                  onClick={() => this.props.onAdd(
                    { key: "equChargeSuccessDetail", titleText: "设备充电成功率" },
                    {
                      equipmentInfo: record,
                    },
                  )}>
                  {text}
                </a>
              );
            },
          },
          {
            name: "设备类型",
            key: "type",
            colType: "textCol",
            align: "center",
            render: (text) => {
              if (text == null)
              {
                return '';
              } else if (parseInt(text) == 0)
              {
                return '交流电';
              } else if (parseInt(text) == 1)
              {
                return '直流电';
              } else if (parseInt(text) == 2)
              {
                return '交直流';
              }
            },
          },
          {
            name: "订单总数",
            key: "totalOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功订单数",
            key: "successOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "失败订单数",
            key: "failureOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功率",
            key: "successRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: this.state.dataSource,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };

  // 类型排序改变事件
  sortTypeChange = async (value) => {
    await this.setState({
      sortType: value,
    });

    this.handleGetDataSource();
  };

  
  handleClick = () => {
    var data = [];
    if (this.state.dataSource != null && this.state.dataSource.length > 0)
    {
      data = this.state.dataSource;
    } else {
      message.error("暂无数据");
      return;
    }
    var option={};
    let dataTable = [];
    if (data) {
      for (let i in data) {
        let obj = {}
        obj['排名'] = data[i]['serial'];
        obj['设备'] = data[i]['stubId'];
        if (data[i]['type'] == null)
        {
          obj['设备类型'] = '';
        }  else if (data[i]['type'] == '0')
        {
          obj['设备类型'] =  '交流电';
        } else if (data[i]['type'] == '1')
        {
          obj['设备类型'] =  '直流电';
        } else if (data[i]['type'] == '2')
        {
          obj['设备类型'] =  '交直流';
        } 
        obj['订单总数'] = data[i]['totalOrder'];
        obj['成功订单数'] = data[i]['successOrder'];
        obj['失败订单数'] = data[i]['failureOrder'];
        obj['成功率'] = data[i]['successRate'] + '%';
        dataTable.push(obj);
      }
    }
    var header = ['排名', '设备', '设备类型', '订单总数', '成功订单数', '失败订单数', '成功率'];
    const format = this.props.timeType === "pickMonth" ? "YYYY.MM" : "YYYY.MM.DD";
    option.fileName = this.props.chooseDate.format(format) + 'TOP100设备'
    option.datas=[
      {
        sheetData:dataTable,
        sheetName:'sheet',
        sheetFilter:header,
        sheetHeader:header,
      }
    ];

    var toExcel = new ExportJsonExcel(option); 
    toExcel.saveExcel(); 
  };


  // 升降序改变事件
  sortOrderChange = async (value) => {
    await this.setState({
      sortOrder: value,
    });

    this.handleGetDataSource();
  };

  // 获取数据源
  handleGetDataSource = () => {
    this.setState({
      loading: true,
    });
    fetchHandler(getStationOrEquRank, {
      ...this.props.params,
      topNum: 100,
      sortType: this.state.sortType,
      sortWay: this.state.sortOrder,
      isStubGroup: 0,
      startTime: this.props.chooseDate
        ? this.props.chooseDate.format(this.getFormatter())
        : this.props.params.startTime,
      endTime: this.props.endDate
        ? this.props.endDate.format(this.getFormatter())
        : this.props.params.endTime,
      time: undefined,
    }).then((res) => {
      if (res && res.code === "success") {
        // res.data = [{"stubId":"99008888","stubGroupId":null,"stubGroupName":null,"totalOrder":7,"successOrder":4,"failureOrder":3,"successRate":"57.14","serial":1},{"stubId":"99008877","stubGroupId":null,"stubGroupName":null,"totalOrder":5,"successOrder":4,"failureOrder":1,"successRate":"80.00","serial":2},{"stubId":"99008833","stubGroupId":null,"stubGroupName":null,"totalOrder":3,"successOrder":3,"failureOrder":0,"successRate":"100.00","serial":3},{"stubId":"1029358001","stubGroupId":null,"stubGroupName":null,"totalOrder":2,"successOrder":2,"failureOrder":0,"successRate":"100.00","serial":4},{"stubId":"2021090101","stubGroupId":null,"stubGroupName":null,"totalOrder":1,"successOrder":1,"failureOrder":0,"successRate":"100.00","serial":5},{"stubId":"3204090601","stubGroupId":null,"stubGroupName":null,"totalOrder":1,"successOrder":1,"failureOrder":0,"successRate":"100.00","serial":6}];
        this.setState(
          {
            dataSource: res.data,
          },
          () => {
            this.initTableConfig();
          },
        );
      }
      this.setState({
        loading: false,
      });
    });
  };

  getFormatter = () => {
    return this.props.timeType === "pickMonth" ? "YYYYMM" : "YYYYMMDD";
  };

  render() {
    const format = this.props.timeType === "pickMonth" ? "YYYY.MM" : "YYYY.MM.DD";

    return (
      <Spin spinning={this.state.loading}>
        <div className='section'>
          <div className='title-box'>
            <div style={{    display: 'flex',alignItems: 'center'}}>
            <div className='title'>
              {this.props.chooseDate
                ? `${this.props.chooseDate.format(format)} TOP100设备`
                : "近7天设备充电情况"}
            </div>
            <Button
              onClick={this.handleClick}
              type="primary"
              disabled={this.state.addDisabled}
              style={{ margin: "5px" }}>
              导出
            </Button>
              </div>
            <div className='search-box'>
              <span className="select-label">排序方式：</span>
              <Select
                value={this.state.sortType}
                onChange={this.sortTypeChange}
                style={{ width: "120px", marginRight: "8px" }}>
                {this.props.sortTypeOptions.map((v) => (
                  <Select.Option value={v.value}>{v.name}</Select.Option>
                ))}
              </Select>
              <Select
                value={this.state.sortOrder}
                onChange={this.sortOrderChange}
                style={{ width: "120px" }}>
                {this.props.sortOrderOptions.map((v) => (
                  <Select.Option value={v.value}>{v.name}</Select.Option>
                ))}
              </Select>
            </div>
          </div>
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </Spin>
    );
  }
}

export default Top100Equipment;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/top100Equipment.js